import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=5f953a18&"
import script from "./VImage.vue?vue&type=script&lang=js&"
export * from "./VImage.vue?vue&type=script&lang=js&"
import style0 from "./VImage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports